import Countdown, { CountdownRenderProps } from 'react-countdown';
import { FC } from 'react';
import { Text, chakra } from '@chakra-ui/react';
import { fromUnixTime } from 'date-fns';
import { useTranslation } from 'next-i18next';

import { TEXT_COLOR } from '../../layouts/EventLayout';

const StyledSpan = ({ children }: any) => {
  return (
    <chakra.span color={'brand.500'} fontWeight="bold" fontSize="3xl">
      {children}
    </chakra.span>
  );
};

const EventTimeCounter = ({ startedAt }: { startedAt: number }) => {
  const { t } = useTranslation(['common']);

  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
  }: CountdownRenderProps) => {
    return (
      <Text fontSize="lg" lineHeight="1.75" color={TEXT_COLOR}>
        <StyledSpan>{days}</StyledSpan>
        {` ${t('common:days')} `}
        <StyledSpan>{hours}</StyledSpan>
        {` ${t('common:hours')} `}
        <StyledSpan>{minutes}</StyledSpan>
        {` ${t('common:minutes')} `}
        <StyledSpan>{seconds}</StyledSpan>
        {` ${t('common:seconds')}`}
      </Text>
    );
  };

  return <Countdown date={fromUnixTime(startedAt)} renderer={renderer} />;
};

export default EventTimeCounter;
